module.exports = __webpack_public_path__ + "static/media/hourglass.27987bb4.png";